import React, { useState, useEffect } from 'react'
// import * as ReactDOM from 'react-dom';
// import { makeStyles } from '@material-ui/core';

// import {
//   DataGrid, faIR,
//   GridToolbarContainer,
//   GridToolbarColumnsButton,
//   GridToolbarFilterButton,
//   GridToolbarExport,
//   GridToolbarDensitySelector,

// } from '@mui/x-data-grid';

// import Box from '@mui/material/Box';
import { SERVER } from '../../constants';
import { AUTH_TYPES } from '../../auth/authConstants';
// import * as XLSX from 'xlsx';
// import moment from 'moment-jalaali'
// import { ROLES } from '../../constants';
import {
  LineChart, Line, Brush,

  PieChart, Pie, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';


const data = [
  {
    xLabel: 'مهر',
    'درخواست خرید (تامین مواد اولیه)': 4,
    'سفارشات خرد': 22,
    'سفارشات عاملین': 43,
    'پشتیبانی': 63,

  },
  {
    xLabel: 'آبان',
    'درخواست خرید (تامین مواد اولیه)': 3,
    'سفارشات خرد': 1,
    'سفارشات عاملین': 3,
  },
  {
    xLabel: 'آذر',
    'درخواست خرید (تامین مواد اولیه)': 4,
    'سفارشات خرد': 11,
    'سفارشات عاملین': 23,
  },
  {
    xLabel: 'دی',
    'درخواست خرید (تامین مواد اولیه)': 1,
    'سفارشات خرد': 3,
    'سفارشات عاملین': 4,
  },
  {
    xLabel: 'بعمن',
    'درخواست خرید (تامین مواد اولیه)': 5,
    'سفارشات خرد': 10,
    'سفارشات عاملین': 23,
  },
  {
    xLabel: 'اسفند',
    'درخواست خرید (تامین مواد اولیه)': 34,
    'سفارشات خرد': 54,
    'سفارشات عاملین': 12,
  },

];

const barData1 = [
  {
    xLabel: 'مهر',
    'درخواست خرید (تامین مواد اولیه)': 4,
    'سفارشات خرد': 22,
    'سفارشات عاملین': 43,
  },
  {
    xLabel: 'آبان',
    'درخواست خرید (تامین مواد اولیه)': 3,
    'سفارشات خرد': 1,
    'سفارشات عاملین': 3,
  },
  {
    xLabel: 'آذر',
    'درخواست خرید (تامین مواد اولیه)': 4,
    'سفارشات خرد': 11,
    'سفارشات عاملین': 23,
  },
  {
    xLabel: 'دی',
    'درخواست خرید (تامین مواد اولیه)': 1,
    'سفارشات خرد': 3,
    'سفارشات عاملین': 4,
  },
  {
    xLabel: 'بعمن',
    'درخواست خرید (تامین مواد اولیه)': 5,
    'سفارشات خرد': 10,
    'سفارشات عاملین': 23,
  },
  {
    xLabel: 'اسفند',
    'درخواست خرید (تامین مواد اولیه)': 34,
    'سفارشات خرد': 54,
    'سفارشات عاملین': 12,
  },

];
// const dataBar2 = [
//   {
//     name: 'Page A',
//     uv: 4000,
//     pv: 2400,
//     amt: 2400,
//   },
//   {
//     name: 'Page B',
//     uv: 3000,
//     pv: 1398,
//     amt: 2210,
//   },
//   {
//     name: 'Page C',
//     uv: 2000,
//     pv: 9800,
//     amt: 2290,
//   },
//   {
//     name: 'Page D',
//     uv: 2780,
//     pv: 3908,
//     amt: 2000,
//   },
//   {
//     name: 'Page E',
//     uv: 1890,
//     pv: 4800,
//     amt: 2181,
//   },
//   {
//     name: 'Page F',
//     uv: 2390,
//     pv: 3800,
//     amt: 2500,
//   },
//   {
//     name: 'Page G',
//     uv: 3490,
//     pv: 4300,
//     amt: 2100,
//   },
// ];
const data01 = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];
const data02 = [
  { name: 'A1', value: 100 },
  { name: 'A2', value: 300 },
  { name: 'B1', value: 100 },
  { name: 'B2', value: 80 },
  { name: 'B3', value: 40 },
  { name: 'B4', value: 30 },
  { name: 'B5', value: 50 },
  { name: 'C1', value: 100 },
  { name: 'C2', value: 200 },
  { name: 'D1', value: 150 },
  { name: 'D2', value: 50 },
];
// const useStyles = makeStyles({
//   charts: {
//     'display': 'flex',
//     'flex-wrap': 'wrap',
//     'padding-left': 0
//   },
//   chartc: {
//     'list-style': 'none',
//     'flex': '0 0 33.333333%'
//   }
// });
const color = ["#8884d8", "#82ca9d", "orange", "pink"]
const color2 = ["#84ced8", "#acca82", "#4c00ff", "#ffc0f8"]
const color3 = ["#84cad8", "#ca9c82", "#00ff0d", "#ebc0ff"]



const MetricCard = ({ title, value }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    margin: '10px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    width: '200px',
    backgroundColor: '#f9f9f9',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
  }}>
    <h4 style={{ margin: 0, color: '#555' }}>{title}</h4>
    <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#333' }}>{value}</span>
  </div>
);

export const BiProfileComponent = () => {
  // const classes = useStyles();

  // const { permissions } = usePermissions();

  const [stats, setStats] = useState({ needsCount: 0, lastLogin: '' });

  // const [chartData, setChartData] = useState({ columns: [], rows: [] })
  const [endpointCalled, setEndpointCalled] = useState(false);
  // const pinnedRows = {
  //   top: [{ id: 0 }],
  // };
  useEffect(() => {
    const token = localStorage.getItem(AUTH_TYPES.AUTHORIZATION);
    const url = `${SERVER}/admin/reportstat`;
    fetch(url, {
      headers: new Headers({
        'Authorization': `${token}`,
      }),

    })
      .then((data) => data.json())
      // .then((data) => setTableRows(data.rows))
      // .then((data) => setChartData(data))
      // .then((data) => tableColumns= data.columns)
      .then((data) => setStats({
        needsCount: data.needsCount || 0,
        lastLogin: data.lastLogin || 'N/A',
      }))

      .then(setEndpointCalled(true))

  }, [])
  return (


    <div style={{ width: '100%' }}>      {/* flexDirection:'row',alignItems:"stretch" */}
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', padding: '20px' }}>
        <MetricCard title="تعداد درخواست‌های ثبت شده" value={stats.needsCount} />
        <MetricCard title="درخواست‌های پاسخ داده شده" value={stats.needsCount} />
        <MetricCard title="آخرین درخواست" value={stats.lastLogin} />
        <MetricCard title="آخرین ورود به سیستم" value={stats.lastLogin} />
      </div>

      <div style={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}>
        {endpointCalled ?
          <>

            <MyBarChart width="50%" data={data} colors={color} />
            <MyLineChart width="50%" data={barData1} colors={color2} />
            <MyBarChart width="50%" data={barData1} colors={color3} />
            <ResponsiveContainer width="50%" height={300}>
              <PieChart width="50%" height={400}>
                <Pie
                  dataKey="value"
                  isAnimationActive={true}
                  data={data01}
                  cx="30%"
                  cy="50%"
                  outerRadius={80}
                  fill="#8884d8"
                  label />
                <Pie dataKey="value" data={data02} cx="70%"
                  cy="50%" innerRadius={40} outerRadius={80} fill="#82ca9d" />
                <Tooltip />
              </PieChart>
            </ResponsiveContainer></>
          : null}
      </div>
    </div >
  )
};

class MyLineChart extends React.Component {

  getLineChart = () => {
    const { colors } = this.props;

    const keysArr = Object.keys(data[0]).slice(1);
    const lineArr = [];
    keysArr.forEach((item, index) => {
      lineArr.push(<Line type="monotone" dataKey={item} stroke={colors[index]} />)
    })
    return lineArr;
  }

  modifyFormatter = (value, name, props) => {
    const nameJSX = <span><span style={{
      display: "inline-block",
      marginRight: "5px",
      borderRadius: "10px",
      width: "10px",
      height: "10px",
      backgroundColor: props.color
    }}></span>{name} : {value}</span>
    return [nameJSX];
  }

  render() {
    return (
      // <ResponsiveContainer>
      <ResponsiveContainer width={this.props.width} height={300}>

        <LineChart
          width={500}
          height={300}
          data={this.props.data}
          margin={{
            top: 5, right: 30, left: 20, bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" horizontal={false} vertical={false} />
          <XAxis dataKey={Object.keys(this.props.data[0])[0]} />
          <YAxis axisLine={false} tickLine={false} />
          <Tooltip formatter={this.modifyFormatter} />
          <Legend />
          {this.getLineChart()}
          <Brush dataKey={Object.keys(this.props.data[0])[0]}>
            <LineChart>
              {this.getLineChart()}
            </LineChart>
          </Brush>
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

class MyBarChart extends React.Component {

  getBar = () => {
    const { stacked, colors } = this.props;
    const keysArr = Object.keys(data[0]).slice(1);
    const barArr = [];
    keysArr.forEach((item, index) => {
      barArr.push(<Bar dataKey={item} stackId={stacked ? "a" : null} fill={colors[index]} />)
    })
    return barArr;
  }

  modifyFormatter = (value, name, props) => {
    console.log(value, name, props, "props");
    const nameJSX = <span><span style={{
      display: "inline-block",
      marginRight: "5px",
      borderRadius: "10px",
      width: "10px",
      height: "10px",
      backgroundColor: props.color
    }}></span>{name} : {value}</span>;
    let result = [nameJSX].reverse();
    // console.log(result, "result");
    return result;
  }

  handleSort = (item1, item2) => {
    // console.log(item1, item2);
    return 1;
  }

  render() {
    return (
      <ResponsiveContainer width={this.props.width} height={300}>
        <BarChart
          width={500}
          height={300}
          data={this.props.data}
          margin={{ top: 5, right: 30, left: 20, bottom: 5, }} >
          <CartesianGrid strokeDasharray="3 3" horizontal={false} vertical={false} />
          <XAxis dataKey={Object.keys(this.props.data[0])[0]} />
          <YAxis axisLine={false} tickLine={false} />
          <Tooltip />
          <Legend />
          {this.getBar()}
          <Brush dataKey={Object.keys(this.props.data[0])[0]}>
            <BarChart>
              {this.getBar()}
            </BarChart>
          </Brush>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
